import React, { useEffect, useState, useRef, MutableRefObject } from 'react'

// resources
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'

// json
import AvailabilityList from 'assets/json/explore/availability.json'
import MarketList from 'assets/json/explore/market.json'
import MediumList from 'assets/json/explore/medium.json'
import CategoryList from 'assets/json/popular-category.json'

// custom functions
import ProfileSearchBox from 'components/Input/ProfileSearchBox'

// styles
import styles from './index.module.scss'

const ExploreFilterTab = props => {
  const {
    exploreType,
    selectedAvailability,
    setSelectedAvailability,
    selectCategory,
    selectedMedium,
    setSelectedMedium,
    selectedMarket,
    setSelectedMarket,
    handleSearch,
    updateSidebarHeight,
  } = props
  const [showListingType, setShowListingType] = useState(false)
  const [showMediumType, setShowMediumType] = useState(false)
  const [showCategoryType, setShowCategoryType] = useState(false)
  const [showListedBy, setShowListedBy] = useState(false)

  const [categoryList, setCategoryList] = useState<any[]>([])

  useEffect(() => {
    updateSidebarHeight()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showListingType, showMediumType, showCategoryType, showListedBy])

  useEffect(() => {
    let array: any[] = []
    CategoryList.map(item => {
      let object: any = item
      object.checked = false
      array.push(object)
    })
    setCategoryList(array)
  }, [])

  const handleSelectCategory = index => {
    let array = [...categoryList]
    array[index].checked = !array[index].checked
    setCategoryList(array)
    selectCategory(array)
  }

  return (
    <div className="w-full">
      <ProfileSearchBox onSearch={handleSearch} />

      {/* Listing Status */}
      {exploreType === 0 && (
        <div className="w-full mt-[30px]">
          <div
            className="w-full flex justify-between items-start gap-[15px]"
            onClick={() => setShowListingType(!showListingType)}
          >
            <div className={`${styles.showListing}`}>Listing Status</div>
            <div className="w-[16px] h-[16px] flex items-center justify-center">
              {showListingType ? <MinusIcon /> : <PlusIcon />}
            </div>
          </div>

          <div className={styles.descBorder} />

          {showListingType && (
            <div className="mt-15px">
              {AvailabilityList.map((item, index) => (
                <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                  <label
                    className={`${styles.checkmark}`}
                    onClick={() => {
                      setSelectedAvailability(item)
                    }}
                  >
                    {item.label}
                  </label>
                  <input
                    className={`${styles.checkbox}`}
                    type="checkbox"
                    id={item.id}
                    checked={selectedAvailability.value == item.value}
                    onChange={() => {
                      setSelectedAvailability(item)
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Listed By */}
      {exploreType === 0 && (
        <div className="w-full mt-[30px]">
          <div
            className="w-full flex justify-between items-start gap-[15px]"
            onClick={() => setShowListedBy(!showListedBy)}
          >
            <div className={`${styles.showListing}`}>Listed By</div>
            <div className="w-[16px] h-[16px] flex items-center justify-center">
              {showListedBy ? <MinusIcon /> : <PlusIcon />}
            </div>
          </div>

          <div className={styles.descBorder} />

          {showListedBy && (
            <div className="mt-15px">
              {MarketList.map((item, index) => (
                <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                  <label
                    className={`${styles.checkmark}`}
                    onClick={() => {
                      setSelectedMarket(item)
                    }}
                  >
                    {item.label}
                  </label>
                  <input
                    className={`${styles.checkbox}`}
                    type="checkbox"
                    id={item.id}
                    checked={selectedMarket.value == item.value}
                    onChange={() => {
                      setSelectedMarket(item)
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Medium Status */}
      {exploreType === 0 && (
        <div className="w-full mt-[30px]">
          <div
            className="w-full flex justify-between items-start gap-[15px]"
            onClick={() => setShowMediumType(!showMediumType)}
          >
            <div className={`${styles.showListing}`}>Medium</div>
            <div className="w-[16px] h-[16px] flex items-center justify-center">
              {showMediumType ? <MinusIcon /> : <PlusIcon />}
            </div>
          </div>

          <div className={styles.descBorder} />

          {showMediumType && (
            <div className="mt-15px">
              {MediumList.map((item, index) => (
                <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                  <label
                    className={`${styles.checkmark}`}
                    onClick={() => {
                      setSelectedMedium(item)
                    }}
                  >
                    {item.label}
                  </label>
                  <input
                    className={`${styles.checkbox}`}
                    type="checkbox"
                    id={item.id}
                    checked={selectedMedium === item}
                    onChange={() => {
                      setSelectedMedium(item)
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Categories Status */}
      <div className="w-full mt-[30px] mb-[100px]">
        <div
          className="w-full flex justify-between items-start gap-[15px]"
          onClick={() => setShowCategoryType(!showCategoryType)}
        >
          <div className={`${styles.showListing}`}>Categories</div>
          <div className="w-[16px] h-[16px] flex items-center justify-center">
            {showCategoryType ? <MinusIcon /> : <PlusIcon />}
          </div>
        </div>

        <div className={styles.descBorder} />

        {showCategoryType && (
          <div className="mt-15px">
            {categoryList.map((item, index) => (
              <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                <label
                  className={`${styles.checkmark}`}
                  onClick={() => {
                    handleSelectCategory(item)
                  }}
                >
                  {item.name}
                </label>
                <input
                  className={`${styles.checkbox}`}
                  type="checkbox"
                  id={item.id}
                  checked={item.checked}
                  onChange={() => {
                    handleSelectCategory(index)
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ExploreFilterTab
